// @generated by protoc-gen-es v2.12.1 with parameter "target=ts"
// @generated from file api/gateway/v1/tenant.proto (package gateway.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Pagination, PaginationMetadata } from "./core_pb";
import { file_api_gateway_v1_core } from "./core_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api/gateway/v1/tenant.proto.
 */
export const file_api_gateway_v1_tenant: GenFile = /*@__PURE__*/
  fileDesc("ChthcGkvZ2F0ZXdheS92MS90ZW5hbnQucHJvdG8SCmdhdGV3YXkudjEiVAoGVGVuYW50EgwKBHV1aWQYASABKAkSDAoEbmFtZRgCIAEoCRIuCgpjcmVhdGVkX2F0GAogASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcCIjChNDcmVhdGVUZW5hbnRSZXF1ZXN0EgwKBG5hbWUYASABKAkiOgoUQ3JlYXRlVGVuYW50UmVzcG9uc2USIgoGdGVuYW50GAEgASgLMhIuZ2F0ZXdheS52MS5UZW5hbnQiJgoWR2V0VGVuYW50QnlVdWlkUmVxdWVzdBIMCgR1dWlkGAEgASgJIj0KF0dldFRlbmFudEJ5VXVpZFJlc3BvbnNlEiIKBnRlbmFudBgBIAEoCzISLmdhdGV3YXkudjEuVGVuYW50IkAKEkxpc3RUZW5hbnRzUmVxdWVzdBIqCgpwYWdpbmF0aW9uGAEgASgLMhYuZ2F0ZXdheS52MS5QYWdpbmF0aW9uImwKE0xpc3RUZW5hbnRzUmVzcG9uc2USIwoHdGVuYW50cxgBIAMoCzISLmdhdGV3YXkudjEuVGVuYW50EjAKCG1ldGFkYXRhGAIgASgLMh4uZ2F0ZXdheS52MS5QYWdpbmF0aW9uTWV0YWRhdGEiMQoTVXBkYXRlVGVuYW50UmVxdWVzdBIMCgR1dWlkGAEgASgJEgwKBG5hbWUYAiABKAkiOgoUVXBkYXRlVGVuYW50UmVzcG9uc2USIgoGdGVuYW50GAEgASgLMhIuZ2F0ZXdheS52MS5UZW5hbnQiIwoTRGVsZXRlVGVuYW50UmVxdWVzdBIMCgR1dWlkGAEgASgJIhYKFERlbGV0ZVRlbmFudFJlc3BvbnNlMrQDCg1UZW5hbnRTZXJ2aWNlElEKDENyZWF0ZVRlbmFudBIfLmdhdGV3YXkudjEuQ3JlYXRlVGVuYW50UmVxdWVzdBogLmdhdGV3YXkudjEuQ3JlYXRlVGVuYW50UmVzcG9uc2USWgoPR2V0VGVuYW50QnlVdWlkEiIuZ2F0ZXdheS52MS5HZXRUZW5hbnRCeVV1aWRSZXF1ZXN0GiMuZ2F0ZXdheS52MS5HZXRUZW5hbnRCeVV1aWRSZXNwb25zZRJOCgtMaXN0VGVuYW50cxIeLmdhdGV3YXkudjEuTGlzdFRlbmFudHNSZXF1ZXN0Gh8uZ2F0ZXdheS52MS5MaXN0VGVuYW50c1Jlc3BvbnNlElEKDFVwZGF0ZVRlbmFudBIfLmdhdGV3YXkudjEuVXBkYXRlVGVuYW50UmVxdWVzdBogLmdhdGV3YXkudjEuVXBkYXRlVGVuYW50UmVzcG9uc2USUQoMRGVsZXRlVGVuYW50Eh8uZ2F0ZXdheS52MS5EZWxldGVUZW5hbnRSZXF1ZXN0GiAuZ2F0ZXdheS52MS5EZWxldGVUZW5hbnRSZXNwb25zZUJmCg5jb20uZ2F0ZXdheS52MUILVGVuYW50UHJvdG9QAaICA0dYWKoCCkdhdGV3YXkuVjHKAgpHYXRld2F5XFYx4gIWR2F0ZXdheVxWMVxHUEJNZXRhZGF0YeoCC0dhdGV3YXk6OlYxYgZwcm90bzM", [file_api_gateway_v1_core, file_google_protobuf_timestamp]);

/**
 * Tenant represents an organization or customer account in the system.
 *
 * @generated from message gateway.v1.Tenant
 */
export type Tenant = Message<"gateway.v1.Tenant"> & {
  /**
   * uuid is the unique identifier for the tenant.
   *
   * @generated from field: string uuid = 1;
   */
  uuid: string;

  /**
   * name is the display name of the tenant.
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * created_at timestamp when the location was created.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp | undefined;
};

/**
 * Describes the message gateway.v1.Tenant.
 * Use `create(TenantSchema)` to create a new message.
 */
export const TenantSchema: GenMessage<Tenant> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_tenant, 0);

/**
 * CreateTenantRequest is the request message for creating a new tenant.
 *
 * @generated from message gateway.v1.CreateTenantRequest
 */
export type CreateTenantRequest = Message<"gateway.v1.CreateTenantRequest"> & {
  /**
   * name is the display name for the new tenant.
   *
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message gateway.v1.CreateTenantRequest.
 * Use `create(CreateTenantRequestSchema)` to create a new message.
 */
export const CreateTenantRequestSchema: GenMessage<CreateTenantRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_tenant, 1);

/**
 * CreateTenantResponse is the response message for the CreateTenant RPC.
 *
 * @generated from message gateway.v1.CreateTenantResponse
 */
export type CreateTenantResponse = Message<"gateway.v1.CreateTenantResponse"> & {
  /**
   * tenant is the newly created tenant.
   *
   * @generated from field: gateway.v1.Tenant tenant = 1;
   */
  tenant?: Tenant | undefined;
};

/**
 * Describes the message gateway.v1.CreateTenantResponse.
 * Use `create(CreateTenantResponseSchema)` to create a new message.
 */
export const CreateTenantResponseSchema: GenMessage<CreateTenantResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_tenant, 2);

/**
 * GetTenantByUuidRequest is the request message for retrieving a tenant by UUID.
 *
 * @generated from message gateway.v1.GetTenantByUuidRequest
 */
export type GetTenantByUuidRequest = Message<"gateway.v1.GetTenantByUuidRequest"> & {
  /**
   * uuid is the unique identifier of the tenant to retrieve.
   *
   * @generated from field: string uuid = 1;
   */
  uuid: string;
};

/**
 * Describes the message gateway.v1.GetTenantByUuidRequest.
 * Use `create(GetTenantByUuidRequestSchema)` to create a new message.
 */
export const GetTenantByUuidRequestSchema: GenMessage<GetTenantByUuidRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_tenant, 3);

/**
 * GetTenantByUuidResponse is the response message for the GetTenantByUuid RPC.
 *
 * @generated from message gateway.v1.GetTenantByUuidResponse
 */
export type GetTenantByUuidResponse = Message<"gateway.v1.GetTenantByUuidResponse"> & {
  /**
   * tenant is the tenant retrieved based on the provided UUID.
   *
   * @generated from field: gateway.v1.Tenant tenant = 1;
   */
  tenant?: Tenant | undefined;
};

/**
 * Describes the message gateway.v1.GetTenantByUuidResponse.
 * Use `create(GetTenantByUuidResponseSchema)` to create a new message.
 */
export const GetTenantByUuidResponseSchema: GenMessage<GetTenantByUuidResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_tenant, 4);

/**
 * ListTenantsRequest is the request message for retrieving a list of tenants.
 *
 * @generated from message gateway.v1.ListTenantsRequest
 */
export type ListTenantsRequest = Message<"gateway.v1.ListTenantsRequest"> & {
  /**
   * pagination contains the pagination parameters for retrieving a specific page of tenants.
   *
   * @generated from field: gateway.v1.Pagination pagination = 1;
   */
  pagination?: Pagination | undefined;
};

/**
 * Describes the message gateway.v1.ListTenantsRequest.
 * Use `create(ListTenantsRequestSchema)` to create a new message.
 */
export const ListTenantsRequestSchema: GenMessage<ListTenantsRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_tenant, 5);

/**
 * ListTenantsResponse is the response message for the ListTenants RPC.
 *
 * @generated from message gateway.v1.ListTenantsResponse
 */
export type ListTenantsResponse = Message<"gateway.v1.ListTenantsResponse"> & {
  /**
   * tenants is the list of tenants for the requested page.
   *
   * @generated from field: repeated gateway.v1.Tenant tenants = 1;
   */
  tenants: Tenant[];

  /**
   * metadata contains additional information about the pagination, such as total count of tenants and the pagination parameters used.
   *
   * @generated from field: gateway.v1.PaginationMetadata metadata = 2;
   */
  metadata?: PaginationMetadata | undefined;
};

/**
 * Describes the message gateway.v1.ListTenantsResponse.
 * Use `create(ListTenantsResponseSchema)` to create a new message.
 */
export const ListTenantsResponseSchema: GenMessage<ListTenantsResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_tenant, 6);

/**
 * UpdateTenantRequest is the request message for updating an existing tenant.
 *
 * @generated from message gateway.v1.UpdateTenantRequest
 */
export type UpdateTenantRequest = Message<"gateway.v1.UpdateTenantRequest"> & {
  /**
   * uuid is the unique identifier of the tenant to update.
   *
   * @generated from field: string uuid = 1;
   */
  uuid: string;

  /**
   * name is the updated display name.
   *
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message gateway.v1.UpdateTenantRequest.
 * Use `create(UpdateTenantRequestSchema)` to create a new message.
 */
export const UpdateTenantRequestSchema: GenMessage<UpdateTenantRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_tenant, 7);

/**
 * UpdateTenantResponse is the response message for the UpdateTenant RPC.
 *
 * @generated from message gateway.v1.UpdateTenantResponse
 */
export type UpdateTenantResponse = Message<"gateway.v1.UpdateTenantResponse"> & {
  /**
   * tenant is the updated tenant.
   *
   * @generated from field: gateway.v1.Tenant tenant = 1;
   */
  tenant?: Tenant | undefined;
};

/**
 * Describes the message gateway.v1.UpdateTenantResponse.
 * Use `create(UpdateTenantResponseSchema)` to create a new message.
 */
export const UpdateTenantResponseSchema: GenMessage<UpdateTenantResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_tenant, 8);

/**
 * DeleteTenantRequest is the request message for deleting a tenant.
 *
 * @generated from message gateway.v1.DeleteTenantRequest
 */
export type DeleteTenantRequest = Message<"gateway.v1.DeleteTenantRequest"> & {
  /**
   * uuid is the unique identifier of the tenant to delete.
   *
   * @generated from field: string uuid = 1;
   */
  uuid: string;
};

/**
 * Describes the message gateway.v1.DeleteTenantRequest.
 * Use `create(DeleteTenantRequestSchema)` to create a new message.
 */
export const DeleteTenantRequestSchema: GenMessage<DeleteTenantRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_tenant, 9);

/**
 * DeleteTenantResponse is the response message for the DeleteTenant RPC.
 *
 * @generated from message gateway.v1.DeleteTenantResponse
 */
export type DeleteTenantResponse = Message<"gateway.v1.DeleteTenantResponse"> & {
};

/**
 * Describes the message gateway.v1.DeleteTenantResponse.
 * Use `create(DeleteTenantResponseSchema)` to create a new message.
 */
export const DeleteTenantResponseSchema: GenMessage<DeleteTenantResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_tenant, 10);

/**
 * TenantService defines the gRPC service for managing tenants.
 *
 * -------------------------------------------------------------------------
 * Tenant CRUD operations
 * -------------------------------------------------------------------------
 *
 * @generated from service gateway.v1.TenantService
 */
export const TenantService: GenService<{
  /**
   * CreateTenant creates a new tenant in the system.
   *
   * @generated from rpc gateway.v1.TenantService.CreateTenant
   */
  createTenant: {
    methodKind: "unary";
    input: typeof CreateTenantRequestSchema;
    output: typeof CreateTenantResponseSchema;
  },
  /**
   * GetTenantByUuid retrieves a tenant by its unique identifier.
   *
   * @generated from rpc gateway.v1.TenantService.GetTenantByUuid
   */
  getTenantByUuid: {
    methodKind: "unary";
    input: typeof GetTenantByUuidRequestSchema;
    output: typeof GetTenantByUuidResponseSchema;
  },
  /**
   * GetTenantListByPage retrieves a paginated list of tenants.
   *
   * @generated from rpc gateway.v1.TenantService.ListTenants
   */
  listTenants: {
    methodKind: "unary";
    input: typeof ListTenantsRequestSchema;
    output: typeof ListTenantsResponseSchema;
  },
  /**
   * UpdateTenant updates an existing tenant's details.
   *
   * @generated from rpc gateway.v1.TenantService.UpdateTenant
   */
  updateTenant: {
    methodKind: "unary";
    input: typeof UpdateTenantRequestSchema;
    output: typeof UpdateTenantResponseSchema;
  },
  /**
   * DeleteTenant removes a tenant from the system.
   *
   * @generated from rpc gateway.v1.TenantService.DeleteTenant
   */
  deleteTenant: {
    methodKind: "unary";
    input: typeof DeleteTenantRequestSchema;
    output: typeof DeleteTenantResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_api_gateway_v1_tenant, 0);

